import { render, staticRenderFns } from "./confidence.label.vue?vue&type=template&id=13d95db9&"
import script from "./confidence.label.vue?vue&type=script&lang=js&"
export * from "./confidence.label.vue?vue&type=script&lang=js&"
import style0 from "./confidence.label.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports